// extracted by mini-css-extract-plugin
module.exports = {"promoCode":"PromoCode__promoCode___ogZm1","promoCodeName":"PromoCode__promoCodeName___2NaWc"};